import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutGLDistributionTable extends Layout {
    sourceJournalDriver: DataSource;
    tableGLDistribution: Table;
}
